import { render, staticRenderFns } from "./WorkAreaForm.vue?vue&type=template&id=dba9bfa6"
import script from "./WorkAreaForm.vue?vue&type=script&lang=js"
export * from "./WorkAreaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports